(function () {
    $(document).ready(function () {
        $('.select-link').on('change', function(){
            window.location = $(this).val();
        });

        // zobrazeni dalsich clanku pro kliknuti na tlacitko s tridou "view-more"
        $('.section-article-results').each(function () {
            let $self = $(this);
            const $viewMore = $self.find('.view-more');
            $viewMore.find('button').on('click', function (e) {
                e.preventDefault();

                let $button = $(this);
                let data = {};
                data.offset = $(this).attr('data-offset');
                data.categoryId = $(this).data('category');
                data.order = $(this).data('order');
                data.count = $(this).data('count');
                data.showTopics = $(this).data('topics');

                $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/article/get-next-article-list',
                    data: data
                }).done(function (response) {
                    $(response.data).insertBefore($viewMore); //vlozeni pred tlacitko

                    if (!response.nextReqResults) {
                        $button.hide(); // skryti tlacitka pokud by v pristim requestu nebyly uz dalsi clanky
                    } else {
                        $button.attr('data-offset', parseInt(data.offset, 10) + data.count); // update offsetu
                    }
                });
            });
        });

        //==========================
        //====SHOW NEXT ARTICLES====
        //==========================

        $('#show-next').on('click', function(e){
            e.preventDefault();
            $('.other-articles').find('.other-article-row').show();
            $(this).hide();
        });

    });
})();


// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/articleLists.js